import cloneDeep from "lodash/cloneDeep";

export default {
  showVesselDetail: state => {
    return state.showVesselDetail;
  },
  showPlotDetail: state => {
    return state.showPlotDetail;
  },
  getCountryName: state => countryCode => {
    let cc = state.countryCodes.filter(country => country.id === countryCode);
    return cc.length > 0 ? cc[0].name_localized : null;
  },
  getCountryAlpha2: state => countryCode => {
    let cc = state.countryCodes.filter(country => country.id === countryCode);
    return cc.length > 0 ? cc[0].alpha2.toLowerCase() : null;
  },
  getVesselDetail: state => {
    return state.vesselDetail;
  },
  isMonitoring: state => vesselId => {
    let result = state.monitoringVessels.filter(function(value) {
      return value.id === vesselId;
    });
    return result.length !== 0;
  },
  isMonitoringLimit: state => {
    return state.monitoringVessels.length >= 5;
  },
  isOwnVessel: state => vesselId => {
    let result = state.ownVessels.filter(function(value) {
      return value.id === vesselId;
    });
    return result.length !== 0;
  },
  getPlotDetail: state => {
    return state.plotDetail;
  },
  isDisplayedVesselDetail: state => vesselId => {
    if (!state.vesselDetail) return false;
    return state.vesselDetail.id === vesselId;
  },
  hasWakes: state => vesselId => {
    return !!state.wakes.get(vesselId);
  },
  getMetoceanInitialDatetime: state => {
    return state.metoceanInitialDatetime;
  },
  getCurrentMetoceanSourceLayerId: state => {
    if (!state.currentWeatherSourceLayerId) {
      return null;
    }
    return state.currentWeatherSourceLayerId;
  },
  getCurrentContourSourceLayerId: state => {
    if (!state.updateContourSourceLayer) {
      return null;
    }
    return state.updateContourSourceLayer.newSourceLayerId;
  },
  getWeatherDisplayedUnixTime: (_state, getters) => {
    if (getters.getMetoceanDisplayedUnixTime)
      return getters.getMetoceanDisplayedUnixTime;
    if (getters.getContourDisplayedUnixTime)
      return getters.getContourDisplayedUnixTime;
    return null;
  },
  getMetoceanDisplayedUnixTime: ({
    showWeatherMenu,
    updateMetoceanSourceLayer,
  }) => {
    return (
      (showWeatherMenu &&
        updateMetoceanSourceLayer &&
        updateMetoceanSourceLayer.displayedUnixTime) ||
      null
    );
  },
  getContourDisplayedUnixTime: ({ showContour, updateContourSourceLayer }) => {
    return (
      (showContour &&
        updateContourSourceLayer &&
        updateContourSourceLayer.displayedUnixTime) ||
      null
    );
  },
  getOffingWavePointNextId: state => {
    if (state.offingWavePoints.length === 0) {
      return 1;
    } else {
      let copyOffingWavePoints = cloneDeep(state.offingWavePoints);
      let id;
      copyOffingWavePoints.some((v, i) => {
        if (i + 1 !== v.pointId) {
          id = i + 1;
          return true;
        }
      });
      if (typeof id === "undefined") {
        return copyOffingWavePoints.length + 1;
      } else {
        return id;
      }
    }
  },
  getOffingWavePoint: state => pointId => {
    let res = state.offingWavePoints.find(el => el.pointId === pointId);
    return cloneDeep(res);
  },
  isLimitOffingWavePoint: state => {
    return state.offingWavePoints.length >= 10;
  },
  getUniqueVesselIdsAcrossFavorites: state => {
    let vesselIds = [];
    state.favoriteList.forEach(favorite => {
      favorite.groupList.forEach(group => {
        group.vessels.forEach(vesselId => {
          vesselIds.push(vesselId);
        });
      });
    });
    return Array.from(new Set(vesselIds));
  },

  getOwnFloatingUnits: state => enterpriseId => {
    // 1つの海上設置物を複数企業に紐付けられるよう
    // enterprise_ids(int[]) の包含判定で絞り込む。
    // enterprise_ids 未付与のドキュメントでも落ちないよう || [] でガードする。
    return state.floatingUnits.filter(floatingUnit =>
      (floatingUnit.enterprise_ids || []).includes(enterpriseId)
    );
  },

  getFilterRadarGrid: state => {
    return state.filterRadarGrid;
  },
};
